// src/lib/funnelGa4.js
//
// Lightweight funnel events into the GTM dataLayer so GA4 (and any other GTM
// tag) can measure the £39 ID-verification funnel's drop-off: landing view →
// CTA click → checkout reached → form started → checkout start (→ purchase,
// which trackPurchase.js already fires). Measurement only — additive and
// consent-safe: pushing to the dataLayer sets no cookies, and Consent Mode /
// GTM gate whether GA4 actually sends. Mirrors trackPurchase.js's approach.
export function pushFunnelEvent(event, params = {}) {
  if (!event || typeof window === 'undefined') return false;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, funnel: 'id_verification', ...params });
  return true;
}

export default { pushFunnelEvent };
